module.exports = __webpack_public_path__ + "img/04.b185d632.png";